import currency from 'currency.js';

export const getTransactionFeeAmount = (config: IPaymentPortalConfig, paymentAmount: number): number => {
  if (config && config.transactionFeeType === TransactionFeeType.PERCENTAGE_TRANSACTION_FEE) {
    // Multiply by the fraction in a single operation so the fee is rounded only once.
    // Chaining .multiply(value).divide(100) rounds the intermediate product, e.g. $11.55 @ 2.9%
    // would yield $0.34 instead of the correct $0.33.
    return currency(paymentAmount).multiply(config.transactionFeeValue / 100).value;
  } else {
    return currency(config && config.transactionFeeValue).value;
  }
};

export const getTotalPaymentAmountValue = (config: IPaymentPortalConfig, paymentAmount: number): number => {
  if (config && config.includeTransactionFee) {
    return currency(paymentAmount).add(getTransactionFeeAmount(config, paymentAmount)).value;
  } else {
    return currency(paymentAmount).value;
  }
};

export const getTransactionFee = (config: IPaymentPortalConfig, paymentAmount: number) =>
  currency(getTransactionFeeAmount(config, paymentAmount)).format();

export const getTotalPaymentAmount = (config: IPaymentPortalConfig, paymentAmount: number) =>
  currency(getTotalPaymentAmountValue(config, paymentAmount)).format();
